export const scopes = {
  ADD_CLINICIAN: 'papi-clinician-create',
  MANAGE_CLINICIANS_LIST: 'papi-clinician-list',
  UPDATE_CLINICIAN: 'papi-clinician-update',
  LOCATION_WRITE: 'papi-location-create',
  LOCATION_READ: 'papi-location-list-2',
  MANAGE_PATIENTS_LIST: 'papi-location-patient-list',
  PRESCRIPTION_REPRESCRIBE: 'papi-order-prescription-create',
  ADD_PATIENT: 'papi-patient-create',
  PATIENT_SUMMARY_LIST: 'papi-patient-list',
  PATIENT_READ: 'papi-patient-read',
  PATIENT_SEARCH: 'papi-patient-search',
  UPDATE_PATIENT: 'papi-patient-update',
  PATIENT_ADHERENCE_LIST: 'papi-patient-adherence-list',
} as const;

/**
 * A curried function that takes in an Array of ScopeGroups and the required scope group.
 * If the scope is found for any of the roles a user might have associated with them then
 * it returns true otherwise it returns false.
 * @param {string[]} currentUserScopes - An array of ScopeGroups for the User
 * @param {string} requiredScope - The required scope that is being searched for
 *
 */
export const hasRequiredScope =
  (currentUserScopes: string[]) =>
  (requiredScope: string | undefined): boolean => {
    if (currentUserScopes.length === 0) return false;
    if (requiredScope == null) return false;
    return currentUserScopes.includes(requiredScope);
  };
